export default "__VITE_ASSET__BRnYtGT9__"